import { render, staticRenderFns } from "./CenterViewEventEdit_Ap.vue?vue&type=template&id=08107a7a&scoped=true"
import script from "./CenterViewEventEdit_Ap.vue?vue&type=script&lang=js"
export * from "./CenterViewEventEdit_Ap.vue?vue&type=script&lang=js"
import style0 from "./CenterViewEventEdit_Ap.vue?vue&type=style&index=0&id=08107a7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08107a7a",
  null
  
)

export default component.exports